import { type Identifier, useTranslate } from "ra-core";

import type { DealActivityType } from "../types";
import type { ActivityOrderingGroup } from "./activityLogRules";
import { PickerButton } from "./PickerButton";

/**
 * Almikia Epic EA (TASK-111), DATA CONTRACT EA (10): the grouped activity
 * list -- "De esta etapa" first, then "Otras actividades" (or a single
 * ungrouped list when the lead's stage has no link at all).
 */
export function ActivityGroupPicker({
  groups,
  selectedId,
  onSelect,
}: {
  groups: ActivityOrderingGroup[];
  selectedId: Identifier | null;
  onSelect: (id: Identifier) => void;
}) {
  const translate = useTranslate();

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="text-sm font-medium mb-1">
        {translate("resources.deals.activity_log.activity_label", {
          _: "Actividad",
        })}
      </legend>
      {groups.map((group) =>
        group.activities.length === 0 ? null : (
          <div key={group.label ?? "all"} className="flex flex-col gap-2">
            {group.label ? (
              <span className="text-xs text-muted-foreground tracking-wide mt-1">
                {translate(
                  group.label === "De esta etapa"
                    ? "resources.deals.activity_log.groups.stage"
                    : "resources.deals.activity_log.groups.other",
                  { _: group.label },
                )}
              </span>
            ) : null}
            {group.activities.map((activity: DealActivityType) => (
              <PickerButton
                key={activity.id}
                selected={selectedId === activity.id}
                onClick={() => onSelect(activity.id)}
              >
                {activity.name}
              </PickerButton>
            ))}
          </div>
        ),
      )}
    </fieldset>
  );
}
